import { Checkbox as MuiCheckbox } from "@mui/material"
import { FormControlLabel } from "@mui/material"
import classNames from "classnames"
import { useState } from "react"

import { CheckboxChecked, CheckboxUnChecked, CheckboxIntermediate } from "@/components/icon/svg"
import { CheckboxBaseProps, CheckboxColor, CheckboxProps } from "@/types/components/checkbox"

import { colorTokens } from "@/components/colorTokens"
import "./checkbox.scss"

/**
 * 체크박스만 렌더링하는 컴포넌트
 * @param CheckboxBaseProps Mui의 체크박스 프롬에 컬러를 확장시킨 프롭.  https://mui.com/material-ui/react-checkbox/
 * @prop CheckboxColor 체크박스의 색상을 정의한 enum BLUE, GREEN, ORANGE, PURPLE, YELLOW, GREY
 */
export function BaseCheckbox({
  className,
  color = CheckboxColor.PLATINUM,
  ...props
}: CheckboxBaseProps) {
  const [isHoveredState, setIsHovered] = useState(false)

  return (
    <MuiCheckbox
      {...props}
      className={classNames("BaseCheckboxCont", className, {
        [`checkbox-${color}`]: color,
        "checkbox-black": !color,
        uncheck: !props.checked && !props.indeterminate,
        isHovered: isHoveredState,
      })}
      icon={<CheckboxUnChecked />}
      checkedIcon={<CheckboxChecked />}
      indeterminateIcon={<CheckboxIntermediate />}
      disableRipple
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  )
}
/**
 * 체크박스에 라벨을 선택적으로 렌더링하는 컴포넌트
 * @param CheckboxProps  BaseCheckbox 프롭과 FormControlLabelProps 프롭중 control을 제외한 나머지 프롭을 받는다. https://mui.com/material-ui/api/form-control-label/
 */
export default function Checkbox({
  className,
  onCheckboxChange,
  indeterminate,
  inputProps,
  touchRippleRef,
  ...props
}: CheckboxProps) {
  const [checkboxClassName, setCheckboxClassName] = useState(className || "")

  const onMouseEnter = () => {
    setCheckboxClassName((className || "").concat(" isHovered"))
  }

  const onMouseLeave = () => {
    setCheckboxClassName(className || "")
  }

  return (
    <FormControlLabel
      {...props}
      label={props.label}
      className={classNames("CheckboxWithLabelCont", className)}
      control={
        <BaseCheckbox
          {...props}
          inputProps={inputProps}
          touchRippleRef={touchRippleRef}
          onChange={onCheckboxChange}
          indeterminate={indeterminate}
          className={checkboxClassName}
        />
      }
      sx={{
        "& .MuiFormControlLabel-label": {
          color: props.checked
            ? colorTokens.text["grey-primary"]
            : colorTokens.text["grey-default"],
          fontSize: "14px",
        },
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
